export default __webpack_public_path__ + "static/media/Washington_DC_Boundary.96da757b.geojson";